import { makeStyles, Theme, createStyles } from "@material-ui/core";

export const listUserStyles = makeStyles((theme: Theme) => createStyles({}));
